import { motion } from 'motion/react';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { duration, ease, travel } from '../theme/tokens';
import { useMotionSafe } from '../motion/useMotionSafe';
import { isAdminPath } from './navigation';

interface PageTransitionProps {
  children: ReactNode;
}

/**
 * Fade-in for the public site. Admin screens switch instantly: staff jump
 * between them all day, and a fade from transparent reads as load time.
 */
const PageTransition = ({ children }: PageTransitionProps) => {
  const { enabled } = useMotionSafe();
  const { pathname } = useLocation();

  if (!enabled || isAdminPath(pathname)) {
    return <>{children}</>;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: travel.sm }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: duration.base, ease: ease.out }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
